export const EstadoAprobacion = Object.freeze({
    SIN_APROBACION: "SIN_APROBACION", 
    PENDIENTE: "PENDIENTE",
    APROBADO: "APROBADO",
    RECHAZADO: "RECHAZADO",
})